export default __webpack_public_path__ + "static/media/pexels-luis-quintero-14302882.d1c07d95.jpg";